<template>
    <section id="privacidade">
      <h2>Política de Privacidade</h2>

      <p><strong>Última atualização:</strong> 16 de maio de 2026</p>

      <p>
        Esta Política de Privacidade explica como o LineApps coleta, utiliza,
        armazena e protege os dados pessoais dos usuários da plataforma,
        em conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD).
      </p>

      <h3>1. Sobre o LineApps</h3>

      <p>
        O LineApps é uma plataforma digital voltada para:
      </p>

      <ul>
        <li>Análise de balanços;</li>
        <li>Processamento de balancetes;</li>
        <li>Geração de indicadores financeiros;</li>
        <li>Organização de informações contábeis.</li>
      </ul>

      <div class="highlight">
        Contato: lineapps@pgpaf.com.br
      </div>

      <h3>2. Dados Coletados</h3>

      <h4>2.1 Dados cadastrais</h4>
      <ul>
        <li>Nome;</li>
        <li>E-mail;</li>
        <li>Empresa;</li>
        <li>Senha criptografada.</li>
      </ul>

      <h4>2.2 Dados técnicos e de segurança</h4>
      <ul>
        <li>Endereço IP;</li>
        <li>Data e hora de acesso;</li>
        <li>Navegador e dispositivo;</li>
        <li>Cookies de autenticação;</li>
        <li>Registros de acesso e segurança.</li>
      </ul>

      <h4>2.3 Dados enviados pelo usuário</h4>

      <p>
        O usuário poderá enviar balancetes, arquivos contábeis e planilhas financeiras.
      </p>

      <p>
        O LineApps realiza processamento automatizado para estruturação e análise de informações contábeis, podendo incluir:
      </p>

      <ul>
        <li>Códigos contábeis;</li>
        <li>Estrutura hierárquica de contas;</li>
        <li>Descrições contábeis;</li>
        <li>Saldos e indicadores financeiros.</li>
      </ul>

      <p>
        Determinadas descrições de contas analíticas poderão ser anonimizadas ou substituídas por descrições genéricas, com a finalidade de reduzir a retenção de informações operacionais desnecessárias e reforçar medidas de privacidade e segurança.
      </p>

      <div class="highlight">
        Sempre que possível, os arquivos enviados são excluídos automaticamente
        após o processamento das informações necessárias ao funcionamento da plataforma.
      </div>

      <h3>3. Finalidade do Tratamento dos Dados</h3>

      <ul>
        <li>Autenticação e acesso à plataforma;</li>
        <li>Processamento de balancetes;</li>
        <li>Geração de análises e indicadores;</li>
        <li>Segurança da aplicação;</li>
        <li>Suporte técnico;</li>
        <li>Prevenção a fraudes;</li>
        <li>Cumprimento de obrigações legais.</li>
      </ul>

      <h3>4. Compartilhamento de Dados</h3>

      <p>
        O LineApps poderá compartilhar dados apenas quando necessário com:
      </p>

      <ul>
        <li>Provedores de hospedagem;</li>
        <li>Serviços de infraestrutura;</li>
        <li>Fornecedores de e-mail transacional;</li>
        <li>Autoridades públicas, quando exigido por lei.</li>
      </ul>

      <p>
        O LineApps não comercializa dados pessoais.
      </p>

      <h3>5. Armazenamento e Segurança</h3>

      <p>
        O LineApps adota medidas técnicas e administrativas para proteção das informações,
        incluindo:
      </p>

      <ul>
        <li>Conexões HTTPS;</li>
        <li>Autenticação segura;</li>
        <li>Controle de acesso;</li>
        <li>Proteção contra acessos não autorizados;</li>
        <li>Monitoramento básico de segurança;</li>
        <li>Backups operacionais.</li>
      </ul>

      <p>
        As senhas dos usuários são armazenadas de forma criptografada.
      </p>

      <h3>6. Retenção de Dados</h3>

      <p>
        Os dados poderão ser armazenados enquanto a conta permanecer ativa,
        pelo período necessário para prestação dos serviços ou para cumprimento
        de obrigações legais.
      </p>

      <h3>7. Cookies</h3>

      <p>
        O LineApps utiliza cookies essenciais para autenticação,
        segurança e funcionamento da plataforma.
      </p>

      <h3>8. Direitos do Usuário</h3>

      <p>
        Nos termos da LGPD, o usuário poderá solicitar:
      </p>

      <ul>
        <li>Confirmação da existência de tratamento;</li>
        <li>Acesso aos dados;</li>
        <li>Correção de informações;</li>
        <li>Exclusão de dados, quando aplicável;</li>
        <li>Informações sobre compartilhamento de dados.</li>
      </ul>

      <h3>9. Responsabilidade do Usuário</h3>

      <p>
        O usuário é responsável por manter suas credenciais seguras,
        utilizar a plataforma de forma adequada e garantir legitimidade
        sobre os dados enviados ao sistema.
      </p>

      <h3>10. Alterações desta Política</h3>

      <p>
        Esta Política poderá ser atualizada periodicamente.
      </p>

      <h3>11. Contato</h3>

      <p>
        E-mail: lineapps@pgpaf.com.br
      </p>
    </section>

</template>

<script>
export default {
  name: "PoliticaPrivacidade",

  methods: {},

  mounted() {},

  created() {},
};

</script>

<style scoped src="@/assets/css/legal.css">
</style>
